import React, { useEffect, useState } from 'react';
import { Space, Table, Tag } from 'antd';
import { useWebsiteStattistic } from '.';
const columns = [
  {
    title: 'Tên',

    render: (_, record) => {
      return (
        <>
          <span>
            {record.product?.name}  {record.variant?.variant_title}
          </span>




        </>
      )
    },
  },
  {
    title: 'Số lượng',
    render: (_, record) => {
      return (
        <>
          {record.quantity}
        </>
      )
    },
  },



];

const Products = () => {
  const { data, filter, setFilter } = useWebsiteStattistic();
  const [topProduct, setTopProduct] = useState([])
  useEffect(() => {
    if (data.top_product_incart) {
      setTopProduct(data.top_product_incart);
    } else {
      setTopProduct([])
    }
  }, [data.top_product_incart])



  return (
    <Table columns={columns} dataSource={topProduct} />
  )
};
export default Products;